<template>
    <div class="right-block">
        <MessagesWidget v-if="projectId && !isMainDomain"/>
        <BLink v-if="showDemo" target="_blank" href="//calendly.com/easycontent/demo" class="btn btn-light btn-sm font-size-lg font-weight-500 schedule-demo ml-1 mr-1" v-ripple>
            <span>schedule demo</span>
        </BLink>
        <BLink :href="`/${helpPath}`" class="p-1 ml-1 mr-1 link-block rounded-circle" :class="{active: isActive([helpPath])}" v-ripple>
            <i class="mi-help-outline top-0 mi-1-5x"></i>
        </BLink>
        <DropdownUser/>
    </div>
</template>

<script>

import {mapGetters, mapState} from "vuex";
import {BLink} from "bootstrap-vue";
import MessagesWidget from "./components/MessagesWidget";
import DropdownUser from "./components/DropdownUser";
import EventBus, {MAIN_WINDOW_CLICK} from "@/utils/event-bus";
import mixinNavbar from "@/mixins/navbar/mixin";

export default {
    name: 'RightBlock',
    components: {
        MessagesWidget,
        BLink,
        DropdownUser
    },
    computed: {
        ...mapGetters(['currentUserCan', 'isCurrentAccountOwner']),
        ...mapState({
            projectId: state => state.navbar.projectId,
            isMainDomain: state => state.navbar.isMainDomain,
        }),
    },
    methods: {
        onWindowClick(event) {
            if (
                this.$refs?.messagesWidget
                && this.$refs.messagesWidget !== event.target
                && !this.$refs.messagesWidget.contains(event.target)
            ) {
                this.showMessagesWidget = false;
            }
        },
    },
    mounted() {
        EventBus.on(MAIN_WINDOW_CLICK, this.onWindowClick);
    },
    destroyed() {
        EventBus.off(MAIN_WINDOW_CLICK, this.onWindowClick);
    },
    mixins: [mixinNavbar],
    data() {
        return {
            showMessagesWidget: false
        }
    }
}
</script>
